import { render, staticRenderFns } from "./accountAdd.vue?vue&type=template&id=3c95e796&scoped=true&"
import script from "./accountAdd.vue?vue&type=script&lang=js&"
export * from "./accountAdd.vue?vue&type=script&lang=js&"
import style0 from "./accountAdd.vue?vue&type=style&index=0&id=3c95e796&lang=scss&scoped=true&"
import style1 from "./accountAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c95e796",
  null
  
)

export default component.exports